import { render, staticRenderFns } from "./TaskTagListAddNew.vue?vue&type=template&id=34c2796a&"
import script from "./TaskTagListAddNew.vue?vue&type=script&lang=js&"
export * from "./TaskTagListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TaskTagListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports